import { fromJS } from 'immutable';

import { SET_STATUS_BAR, CLEAR_STATUS_BAR } from './constants';

const initialState = fromJS({
  message: null,
  colour: null,
});

function statusBarReducer(state = initialState, action) {
  switch (action.type) {
  case SET_STATUS_BAR:
    return state
      .set('message', action.message)
      .set('colour', action.colour);
  case CLEAR_STATUS_BAR:
    return state
      .set('message', null).set('colour', null);
  default:
    return state;
  }
}

export default statusBarReducer;



/** WEBPACK FOOTER **
 ** ./src/containers/status-bar/reducer.js
 **/